import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { informationFlowPlugin } from './modules/informationFlow';
import { serviceDirectoryPlugin } from './modules/serviceDirectory';

export default createApp({
  features: [
    catalogPlugin,
    informationFlowPlugin,
    serviceDirectoryPlugin,
    navModule,
    homeModule,
  ],
});
